module.exports = __webpack_public_path__ + "3e2e982c5282ae6fff51e1f376b8f45f.jpg";


//////////////////
// WEBPACK FOOTER
// ./img/mobile/m-service-img2.jpg
// module id = 244
// module chunks = 2